import styled from '@emotion/styled';

export const CarouselContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const CarouselViewport = styled.div`
  overflow: hidden;
  border-radius: 8px;
`;

export const CarouselTrack = styled.div<{ $activeIndex: number }>`
  display: flex;
  transition: transform 0.5s ease-in-out;
  transform: translateX(-${({ $activeIndex }) => $activeIndex * 100}%);
`;

export const CarouselSlide = styled.div`
  min-width: 100%;
  flex-shrink: 0;
`;

export const CarouselDots = styled.div`
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 8px;
`;

export const CarouselDot = styled.button<{ $active: boolean }>`
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: none;
  padding: 0;
  cursor: pointer;
  background: ${({ $active }) => ($active ? '#0b29fb' : '#d0d0d0')};
  transition: background 0.2s ease;

  &:hover {
    background: ${({ $active }) => ($active ? '#0b29fb' : '#a8a8a8')};
  }

  &:focus-visible {
    outline: 2px solid #0b29fb;
    outline-offset: 2px;
  }
`;
